import React from 'react';
import { navData } from '../data'; 
import { Link } from 'react-router-dom';

const Nav = () => {
  const { items } = navData;

  return (
    <nav>
      <ul className='flex gap-x-[35px]'>
        {items.map((item, index) => (
          <li key={index}>
            {item.href.startsWith('/') ? (
              // Use Link for all internal routes
              <Link
              className="link hover:border-b-2 hover:border-red-400 transition duration-300"
              to={window.location.pathname === '/project' ? `/#${item.href.slice(1)}` : item.href}
            >
              {item.name}
            </Link>
              // <Link
              //   className='link hover:border-b-2 hover:border-red-400 transition duration-300'
              //   to={item.href}
              // >
              //   {item.name}
              // </Link>
            ) : (
              // Use <a> for external links
              <a
                className='link hover:border-b-2 hover:border-red-400 transition duration-300'
                href={item.href}
                target={item.target || '_self'}
                rel={item.target === '_blank' ? 'noopener noreferrer' : ''}
              >
                {item.name}
              </a>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;



// import React from 'react';
// import { navData } from '../data'; 
// import { Link } from 'react-router-dom';

// const Nav = () => {
//   const {items} = navData;
//   return (<nav>
//     <ul className='flex gap-x-[35px]'>
//       {items.map((item, index)=>{
//         return (
//         <li key={index}>
//           {item.href.startsWith('/') ? (
//                 <Link
//                   className='link hover:border-b-2 hover:border-red-400 transition duration-300'
//                   to={item.href}
//                 >
//                   {item.name}
//                 </Link>
//               ) : (
//                 <a
//                   className='link hover:border-b-2 hover:border-red-400 transition duration-300'
//                   href={item.href}
//                   target={item.target || '_self'}
//                   rel={item.target === '_blank' ? 'noopener noreferrer' : ''}
//                 >
//                   {item.name}
//                 </a>
//               )}
//           {/* <a className='link hover:border-b-2 hover:border-red-400 transition duration-300' href={item.href}>{item.name}</a> */}
//         </li>
//       );
//       })}
//     </ul>
//   </nav>);
// };

// export default Nav;
